import styled from 'styled-components'

import { Button, PencilIcon } from '@blade/ui-kit'

import type { WalletModel } from '@root/entities/wallet'

export const EditButton = ({
  wallet,
  onEditClick,
}: {
  wallet: WalletModel
  onEditClick: (wallet: WalletModel) => void
}) => {
  const handleClick = () => {
    onEditClick(wallet)
  }

  return (
    <EditButtonRoot
      size="h32"
      radius="rounded"
      variant="solid"
      color="gray"
      iconLeft={<PencilIcon />}
      onClick={() => {
        handleClick()
      }}
    />
  )
}
const EditButtonRoot = styled(Button)`
  &&& {
    width: 24px;
    background: var(--background-2);
    color: var(--text-10);

    border-radius: 4px;
    &:hover {
      background: var(--background-3);
      color: var(--text-11);
    }
  }
`
